module.exports = "<div class=tree-node id={{id}}> <span class=icon></span> <span class=\"node-check unchecked_box\"></span> <span class=node-text></span> </div> ";


//////////////////
// WEBPACK FOOTER
// ./app/components/util/tree/treeNode/treeNode.html
// module id = 2090
// module chunks = 50